import instance from '@/assets/axios/axios'

export function saveForm(parameters) {
    return instance.post('/saveForm.jspx', parameters)
}

export function sendPhoneCode(parameters) {
    return instance.post('/sendPhoneCode.jspx', parameters)
}

export function contentInfo_channelId(parameters) {
    return instance.post('/contentInfo_channelId.jspx', parameters)
}

export function contentTxtByContentId(parameters) {
    return instance.get('/contentTxtByContentId.jspx', {
        params: parameters
    })
}

export function contentTagByCount(parameters) {
    return instance.post('/contentTagByCount.jspx', parameters)
}

export function contentExtByContentId(parameters) {
    return instance.post('/contentExtByContentId.jspx', parameters)
}

export function contentViewById(parameters) {
    return instance.get('/contentViewById.jspx', {
        params: parameters
    })
}

export function queryCompanyName(parameters) {
    return instance.post('/queryCompanyName.jspx', parameters)
}